import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetDefinitionAudioResponse } from './get-definition-audio-response';
import { getDefinitionAudioResponseSchema } from './get-definition-audio-response';

export async function getDefinitionAudioApi(
  slug: string,
): Promise<IValidatedResponse<IGetDefinitionAudioResponse>> {
  return getRequest<IGetDefinitionAudioResponse>({
    path: `/challenges/${slug}/audio/definition`,
    schema: getDefinitionAudioResponseSchema,
  });
}
